import React from "react";

function Badge({link, name}) {
    return ( 
        <div className="badge">
            <img className="badge__image" src={link} alt={name}  />
        </div>
     );
}

export default Badge;